// extracted by mini-css-extract-plugin
export var cancelButton = "_n4-5";
export var content = "_n4-3";
export var createButton = "_n4-6";
export var drawerContainer = "_n4-0";
export var footer = "_n4-2";
export var header = "_n4-1";
export var orderFormColumn = "_n4-4";